import styled, { css } from 'styled-components';
import { ApMenu, colors } from '@alixpartners/ui-components';

export const Wrapper = styled.nav`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-left: auto;
`;

// export const Label = styled.td`
// 	font-size: 16px;
// 	line-height: 32px;
// 	font-weight: normal;
// 	padding: 12px 12px 12px 0px;
// `;

export const ButtonWrapper = styled.div`
	padding-top: 20px;
`;

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const Button = styled.button`
	flex: 1;
	padding: 10px;
	border: none;
	outline: none;
	font-size: 16px;
	color: white;
	background-color: #488929;
	cursor: pointer;
	position: relative;
`;
export const DownloadDeckBtn = styled.button`
	max-width: 100%;
	height: 38px;
	border: none;
	font-weight: 500;
	font-size: 13px;
	-webkit-letter-spacing: 0.3px;
	-moz-letter-spacing: 0.3px;
	-ms-letter-spacing: 0.3px;
	letter-spacing: 0.3px;
	text-transform: uppercase;
	color: #ffffff;
	border: 1px solid transparent;
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-webkit-justify-content: space-between;
	-ms-flex-pack: justify;
	justify-content: space-between;
	-webkit-align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	padding: 10px 10px 10px 10px;
	background-color: #488929;
	outline: none;
	cursor: pointer;
`;
export const CounterWrapper = styled.div`
	position: absolute;
	right: 8px;
	top: -8px;
	border-radius: 16px;
	background-color: ${colors.green2};
	height: 16px;
	min-width: 16px;
	color: white;
	font-size: 11px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px;
	z-index: 2;
`;

export const StyledMenu = styled(ApMenu)`
	padding-bottom: 0 !important;
	overflow: hidden !important;
	display: flex;
	flex-direction: column;
	max-width: 272px !important;
	min-width: 200px !important;
	max-height: calc(100% - 102px) !important;

	${({ isVirtualList }) =>
		isVirtualList &&
		css`
			height: 100%;
		`};
`;

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;
	z-index: 50;
`;

export const PopupContainer = styled.div`
	background-color: white;
	border-radius: 0.5rem;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
	width: 100%;
	max-width: 28rem;
	padding: 1.5rem;
	position: relative;
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 1rem;
	right: 1rem;
	color: #16a34a; /* green-600 */
	background: none;
	border: none;
	cursor: pointer;

	&:hover {
		color: #15803d; /* green-700 */
	}
`;

export const Title = styled.h2`
	font-size: 1.5rem;
	font-weight: 600;
	color: #1f2937; /* gray-800 */
	margin-bottom: 1.5rem;
`;

export const FormSection = styled.div`
	display: flex;
	justify-content: normal;
	column-gap: 24px;
	margin-bottom: 1.5rem;
	margin-top: 1rem;
`;

export const IndustryWrapper = styled.div`
	display: flex;
	margin-bottom: 28px;
	justify-content: normal;
	column-gap: 8px;
`;

export const Label = styled.label`
	display: block;
	color: #374151; /* gray-700 */
	font-weight: 500;
	margin-bottom: 0.5rem;
`;

export const Select = styled.select`
	width: 100%;
	border: 1px solid #d1d5db; /* gray-300 */
	border-radius: 0.5rem;
	padding: 0.5rem 0.75rem;

	&:focus {
		outline: none;
		ring: 1px;
		ring-color: #16a34a; /* green-500 */
	}
`;

export const CheckboxGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const CheckboxContainer = styled.div`
	display: flex;
	align-items: center;
	margin-top: -9px;
	margin-left: 10px;
`;

export const Checkbox = styled.input`
	width: 1rem;
	height: 1rem;
	color: #16a34a; /* green-600 */
	border-color: #d1d5db; /* gray-300 */
	border-radius: 0.25rem;

	&:focus {
		ring-color: #16a34a; /* green-500 */
	}
`;

export const CheckboxLabel = styled.label`
	margin-left: 0.5rem;
	color: #374151; /* gray-700 */
`;

export const DownloadButton = styled.button`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.5rem 1rem;
	background-color: #16a34a; /* green-600 */
	color: white;
	font-weight: 500;
	border-radius: 0.5rem;
	border-radius: 0.25rem;
	border: none;
	cursor: pointer;
	transition: background-color 0.2s;

	&:hover {
		background-color: #15803d; /* green-700 */
	}
`;
